import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import PatternsList from "../components/PatternsList";

const mapStateToProps = state => ({
  lng:  state.locale.lng
});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(PatternsList);
const withTranslationComponent = withTranslation(["patternsList", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/PatternsList.js